import { useTranslation } from "react-i18next"

const LandscapeComponent = () => {
    const { t } = useTranslation()
    return(<p>
        {t("landscape.text", "Please rotate your screen.")}
    </p>)
}

export default LandscapeComponent